import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.push.js";
import serverList from "../../../components/serverList/serverOptions.vue";
import infoList from "@/mixins/infoList";
import { payUserRank } from "@/api/data";
export default {
  components: {
    serverList: serverList
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: payUserRank,
      value: "role_id",
      inputNum: "100",
      changeName: "",
      searchInfo: {
        grouping: "",
        server_id: []
      },
      options: [{
        value: "open_id",
        label: "账号查询"
      }, {
        value: "role_id",
        label: "角色维度查询"
      }],
      titleName: "role_id",
      showType: "role_id"
    };
  },
  watch: {
    value: function value(newVal) {
      this.titleName = newVal;
    }
  },
  created: function created() {
    var _this = this;
    // 因为服务器列表是做了缓存，自动选择上次的选项，所以要等服务器列表选择完成后再请求获取列表数据
    this.$nextTick(function () {
      _this.checkPage();
    });
  },
  methods: {
    formatDate: function formatDate(time) {
      if (new Date().getTime() - new Date(time).getTime() > 172800000) {
        return 1;
      } else {
        return 0;
      }
    },
    checkPage: function checkPage() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this2.titleName) {
                _context.next = 4;
                break;
              }
              _this2.searchInfo.grouping = _this2.titleName;
              _context.next = 6;
              break;
            case 4:
              _this2.$message({
                message: "请选择查询类别",
                type: "warning"
              });
              return _context.abrupt("return");
            case 6:
              if (/^[0-9]*[1-9][0-9]*$/.test(_this2.inputNum)) {
                _context.next = 11;
                break;
              }
              _this2.inputNum = "";
              _this2.$message({
                message: "页码应该是正整数",
                type: "warning"
              });
              _context.next = 15;
              break;
            case 11:
              _this2.pageSize = _this2.inputNum;
              _context.next = 14;
              return _this2.getTableData();
            case 14:
              if (!_this2.tableData || _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else {
                _this2.showType = _this2.searchInfo.grouping;
                console.log(_this2.showType);
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取到这一行的roleID然后跳转到玩家信息
    goRouterMsg: function goRouterMsg(e) {
      console.log("e", e);
      this.$router.push({
        name: "userRoleInfo",
        query: {
          roleId: e
        }
      });
    },
    open2: function open2() {
      this.$notify({
        title: "充值排行",
        message: "(1)查询历史总充值排行，可选择按账号或者角色维度查询。" + "(2)可选择服务器，打开默认选中全部服务器，但不查询，需要手动点查询后再展示数据，根据总充值金额倒序排列。" + "(3)数据列包括排名、账号、角色Id，角色名、区服、等级、充值金额、注册时间、最后登录时间。",
        duration: 0
      });
    }
  }
};